import RowArea from "./row";

function ListArea(props: any) {
  let myProps = {
    infoArr: [],
    go_start_study: (inData: any) => { },
    ...props
  };

  const get_card_list_tags = () => {
    let card_list_tags: any = myProps.infoArr.map((info: any, index: number) => {
      return (
        <RowArea key={index}
          info={info}
          go_start_study={myProps.go_start_study}
        ></RowArea>
      );
    });
    return card_list_tags;
  };

  return (
    <div>
      {myProps.infoArr.length > 0 &&
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
          {get_card_list_tags()}
        </div>
      }
      {myProps.infoArr.length === 0 &&
        <div style={{ lineHeight: "60px", color: "#777", textAlign: "center" }}>
          검색 결과가 없습니다.
        </div>
      }
    </div>
  );
};

export default ListArea;